import { IBageTypes } from "./BageTypes"
import { StyledChakraBage } from "./StyledBage"

const Bage: React.FC<IBageTypes> = ({ value, top, right }) => {
  return (
    <StyledChakraBage
      top={top}
      right={right}
      position={"absolute"}
      height={"23px"}
      width={"23px"}
      borderRadius={"100%"}
    >
      {value}
    </StyledChakraBage>
  )
}

export default Bage
